import { create } from "zustand";

interface ToastCreator {
  type: "success" | "warning";
  text: string;
  id?: string;
}

interface Toast extends ToastCreator {
  id: string;
}

interface NotificationStore {
  notifications: Toast[];
  addNotification: (notification: ToastCreator) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
}

export const useNotifications = create<NotificationStore>()((set) => ({
  notifications: [],
  addNotification(notification) {
    notification.id =
      notification?.id || Math.random().toString() || crypto?.randomUUID();
    set((state) => ({
      notifications: [...state.notifications, notification as Toast],
    }));
  },
  removeNotification(id) {
    set((state) => ({
      notifications: state.notifications.filter(
        (notification) => notification.id !== id
      ),
    }));
  },
  clearNotifications() {
    set({ notifications: [] });
  },
}));
